import { BuyerCard } from 'src/components/Selectors/BuyerSelector/BuyerCard';
import { useContent } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { SectionContent } from 'src/modals/common/Detail/Detail.styled';
import { DetailSection } from 'src/modals/common/DetailSection';
import { useRetailSaleContext } from 'src/modals/RetailSale/RetailSaleLocalContext';
import { ContentId } from 'src/utils/constants/contentId';

import { RetailSaleEarningsSection } from './RetailSaleCheckoutStep.components';
import { RetailSalePaymentSection } from './RetailSalePaymentSection';

export const RetailSaleCheckoutStep = () => {
  const { selectedBuyer, disabled } = useRetailSaleContext();
  const customerInfoMsg = useContent(ContentId.CustomerInfo);

  return (
    <Stack direction="column" gap="l">
      {selectedBuyer && (
        <DetailSection name={customerInfoMsg}>
          <SectionContent numOfColumns={1}>
            <BuyerCard buyer={selectedBuyer} />
          </SectionContent>
        </DetailSection>
      )}

      <RetailSaleEarningsSection disabled={disabled} />

      <RetailSalePaymentSection />
    </Stack>
  );
};
